<template>
    <div>
        <b-modal
            id="add-application-popup"
            ref="modal"
            :title="title"
            :hide-header-close="loading"
            size="sm"
            hide-footer
            modal-class="hide-footer"
            no-close-on-backdrop
            no-close-on-esc
            @hidden="onHidden"
        >
            <b-form
                @submit.stop.prevent="onSubmit()"
                @reset.stop.prevent="onHidden"
            >
                <div class="row custom-model-form">
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Application Title"
                            label-for="app-title"
                        >
                            <b-form-input
                                id="app-title"
                                v-model="formData.title"
                                v-validate="{
                                    required: true,
                                    max: 50,
                                    min: 6,
                                }"
                                type="text"
                                name="title"
                                :class="{
                                    'is-invalid': errors.has('title'),
                                }"
                                autocomplete="no"
                                placeholder="Enter application title"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Domain"
                            label-for="app-domain"
                        >
                            <b-form-input
                                id="app-title"
                                v-model="formData.domain"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="domain"
                                :class="{
                                    'is-invalid': errors.has('domain'),
                                }"
                                autocomplete="no"
                                placeholder="Enter application domain"
                            ></b-form-input>
                        </b-form-group>
                    </div>
                    <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="Bundle Id"
                            label-for="app-bundle-Id"
                        >
                            <b-form-input
                                id="app-bundle-Id"
                                v-model="formData.bundleId"
                                v-validate="{
                                    required: true,
                                }"
                                type="text"
                                name="bundle Id"
                                :class="{
                                    'is-invalid': errors.has('bundle Id'),
                                }"
                                autocomplete="no"
                                placeholder="Enter application bundle Id"
                            ></b-form-input>
                          </b-form-group>
                       </div>

                                        <div class="col-md-12">
                        <b-form-group
                            id="input-group-1"
                            label="IDV SDK"
                            label-for="app-domain"
                        >
                            <b-form-radio-group
                                v-model="formData.idvOption"
                                v-validate="{
                                    required: true,
                                }"
                                :options="[
                                    { text: 'Yes', value: true },
                                    { text: 'No', value: false },
                                ]"
                                name="idvOption"
                                :class="{
                                    'is-invalid': errors.has('idvOption'),
                                }"
                            ></b-form-radio-group>
                        </b-form-group>
                    </div>

                    <!-- This div is now conditionally shown based on the value of idvOption -->
                    <div class="col-md-12" v-if="formData.idvOption">
                        <b-form-group
                            id="input-group-2"
                            label="Sdk Type"
                            label-for="app-domain"
                        >
                            <b-form-select
                                id="app-domain"
                                v-model="formData.device"
                                v-validate="{
                                    required: false,
                                }"
                                name="Sdk Type"
                                :options="domainOptions"
                                :class="{
                                    'is-invalid': errors.has('select sdk type'),
                                }"
                                placeholder="Select application type"
                            ></b-form-select>
                        </b-form-group>
                    </div>


                    <!--<div class="col-md-12">-->
                    <!--<div class="form-group">-->
                    <!--<label for="data-segments">Data Segments</label>-->
                    <!--<multiselect-->
                    <!--v-model="selectedIds"-->
                    <!--v-validate="{-->
                    <!--required: true,-->
                    <!--}"-->
                    <!--label="code"-->
                    <!--name="data segments"-->
                    <!--placeholder="Select data segment"-->
                    <!--track-by="id"-->
                    <!--:class="{-->
                    <!--'is-invalid': errors.has('data segments'),-->
                    <!--}"-->
                    <!--:options="options"-->
                    <!--:multiple="true"-->
                    <!--&gt;<template slot="noResult"-->
                    <!--&gt;No Record Found</template-->
                    <!--&gt;</multiselect-->
                    <!--&gt;-->
                    <!--</div>-->
                    <!--</div>-->
                    <div v-if="selectedItem" class="col-sm-12">
                        <b-form-group
                            id="api-key-input"
                            label="API KEY"
                            label-for="api-key"
                            class="disable-clipboard"
                        >
                            <b-form-input
                                id="api-key-field"
                                v-model="formData.apiKey"
                                type="text"
                                placeholder="Enter Api key"
                                data-vv-name="apiKey"
                                class="disable-input input-elipsis"
                            >
                            </b-form-input>
                            <i
                                v-b-tooltip.hover
                                class="icon-copy has-icon"
                                title="COPY API KEY"
                                @click="copyApiKey()"
                            ></i>
                        </b-form-group>
                    </div>
                    <div v-if="selectedItem" class="col-sm-12">
                        <b-form-group
                            id="secret-key-input"
                            label="SECRET KEY"
                            label-for="secret-key"
                            class="disable-clipboard"
                        >
                            <b-form-input
                                id="secret-key-field"
                                v-model="formData.apiSecret"
                                type="text"
                                placeholder="Enter Secret key"
                                data-vv-name="apiSecret"
                                class="disable-input input-elipsis"
                            >
                            </b-form-input>
                            <i
                                v-b-tooltip.hover
                                class="icon-copy has-icon"
                                title="COPY SECRET KEY"
                                @click="copySecretKey()"
                            ></i>
                        </b-form-group>
                    </div>
                </div>
                <div class="col-md-12 action-buttons">
                    <base-button
                        :btn-label="buttonLabel"
                        btn-type="submit"
                        btn-variant="primary"
                        :class="loading ? 'disabled' : ''"
                    ></base-button>
                    <base-button
                        btn-label="Cancel"
                        btn-type="reset"
                        btn-variant="link"
                    ></base-button>
                </div>
            </b-form>
            <base-toast></base-toast>
        </b-modal>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import _ from 'lodash'
import resource from '@/api/resource'

const apiAccess = new resource('access-control/api-access')
const dataSegmentApi = new resource('access-control/data-segments')
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > components
    |--------------------------------------------------------------------------
    */
    components: {
        Multiselect,
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props
    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            selectedIds: [],
            formData: this.initializeFormData(),
            options: [],
            domainOptions: [
                { value: null, text: 'Please select a device type' },
                { value: 'android', text: 'Android' },
                { value: 'react', text: 'React Native' },
                { value: 'ios', text: 'ios' },
            ],
        }
    },
    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['loading', 'selectedItem', 'hidePopup']),
        title() {
            return this.selectedItem ? 'Modify Application' : 'Add Application'
        }, // End of title() method

        buttonLabel() {
            return this.selectedItem ? 'Update' : 'Create'
        },
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        /**
         * Handle when the selected has been updated
         *
         * @return {void}
         */
        selectedItem(value) {
            let self = this
            if (value !== null && value !== undefined) {
                Object.assign(this.formData, value)
                this.formData.id = value._id
                this.selectedIds = []
                if (!this.formData.dataSegmentIds.length) {
                    self.selectedIds.push({
                        code: 'All',
                        id: 'all',
                    })
                } else {
                    this.formData.dataSegments.forEach(function (val) {
                        self.selectedIds.push({ code: val.code, id: val._id })
                    })
                }
            } else if (this.$refs.modal._isShown) {
                this.$refs.modal.hide()
            } else {
                this.onHidden()
            }
        },

        hidePopup(value) {
            if (value) {
                this.onHidden()
            }
        },
        selectedIds(val) {
            let allSelected = _.find(val, { id: 'all' })
            if (allSelected) {
                _.remove(val, function (n) {
                    return n.id != 'all'
                })
                this.options.forEach(function (ele) {
                    if (ele.id !== 'all') {
                        ele.$isDisabled = true
                    }
                })
            } else {
                this.options.forEach(function (ele) {
                    ele.$isDisabled = false
                })
            }
        },
    }, // End of Component > watch

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getDataSegments()
    },
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        //initialize form data
        initializeFormData() {
            return {
                id: '',
                title: '',
                domain: '',
                bundleId: '',
                dataSegmentIds: [],
                apiSecret: '',
                apiKey: '',
                idvOption: false,
                device: '',
            }
        },
        async onSubmit() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    this.$store.commit('setLoading', true)
                    this.formData.dataSegmentIds = _.map(this.selectedIds, 'id')
                    let data = []
                    if (this.formData.id) {
                        delete this.formData.dataSegmentCodes
                        delete this.formData.dataSegments
                        delete this.formData.status
                        data = await apiAccess.update(
                            this.formData._id,
                            this.formData
                        )
                    } else {
                        //add application access
                        data = await apiAccess.store(this.formData)
                    }
                    data = data.data

                    if (data) {
                        this.$store.commit('setSuccess', data.message)
                    }
                } catch (error) {
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setError', error)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
        /**
         * Handle when the modal is closed
         *
         * @return {void}
         */
        onHidden() {
            // clear the selected item
            this.$store.commit('clearItem')
            this.selectedIds = []
            this.$store.commit('setLoading', false)

            Object.assign(this.formData, this.initializeFormData())
            this.$validator.reset()
            this.$refs.modal.hide()
        }, // End of onHidden() method

        copyApiKey() {
            var copyApiText = document.getElementById('api-key-field')
            copyApiText.select()
            copyApiText.setSelectionRange(0, 99999)
            document.execCommand('copy')
            this.$toasted.show('Api key has been copied!', {
                duration: 2000,
                type: ['success'],
            })
        },
        copySecretKey() {
            var copySecretText = document.getElementById('secret-key-field')
            copySecretText.select()
            copySecretText.setSelectionRange(0, 99999)
            document.execCommand('copy')
            this.$toasted.show('Secret key has been copied!', {
                duration: 2000,
                type: ['success'],
            })
        },
        async getDataSegments() {
            let self = this
            //data segments list

            let dataSegmentList = await dataSegmentApi.list({
                status: 'active',
                perPage: 1000,
            })
            self.options.push({ code: 'ALL', id: 'all' })
            dataSegmentList.data.data.forEach(function (val) {
                self.options.push({ code: val.code, id: val._id })
            })
        },
    },
}
</script>
